export const CALL_REROUTED = 'CALL_REROUTED';
export const CALL_OUT_OF_JURISDICTION = 'CALL_OUT_OF_JURISDICTION';
export const RTI_DOWNSTREAM_SHARE = 'RTI_DOWNSTREAM_SHARE';
